import { useEffect, useRef } from "react";

export const Starfield = () => {
  const ref = useRef(null);

  useEffect(() => {
    const cv = ref.current;
    const ctx = cv.getContext("2d");
    const dpr = Math.min(window.devicePixelRatio || 1, 2);
    let w = 0, h = 0, raf, stars = [], shoot = null, mx = 0, my = 0;

    const resize = () => {
      w = cv.offsetWidth;
      h = cv.offsetHeight;
      cv.width = w * dpr;
      cv.height = h * dpr;
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
      stars = Array.from({ length: Math.round((w * h) / 4500) }, () => ({ x: Math.random() * w, y: Math.random() * h, z: Math.random() * 0.9 + 0.1, r: Math.random() * 1.1 + 0.3, p: Math.random() * 6.28 }));
    };
    const move = (e) => {
      mx = e.clientX / window.innerWidth - 0.5;
      my = e.clientY / window.innerHeight - 0.5;
    };
    const draw = (t) => {
      ctx.clearRect(0, 0, w, h);
      for (const s of stars) {
        ctx.globalAlpha = (0.3 + 0.7 * Math.abs(Math.sin((t / 1000) * s.z * 1.4 + s.p))) * s.z;
        ctx.fillStyle = s.z > 0.88 ? "#9FF8FF" : "#E2E8F0";
        ctx.beginPath();
        ctx.arc(s.x - mx * 36 * s.z, s.y - my * 36 * s.z, s.r * s.z + 0.2, 0, 6.283);
        ctx.fill();
      }
      if (!shoot && Math.random() < 0.005) shoot = { x: w * (0.15 + Math.random() * 0.6), y: h * Math.random() * 0.4, vx: 7 + Math.random() * 4, vy: 2.4 + Math.random() * 2, life: 1 };
      if (shoot) {
        const tx = shoot.x - shoot.vx * 14, ty = shoot.y - shoot.vy * 14;
        const g = ctx.createLinearGradient(shoot.x, shoot.y, tx, ty);
        g.addColorStop(0, "rgba(160,250,255,0.95)");
        g.addColorStop(1, "rgba(0,240,255,0)");
        ctx.globalAlpha = shoot.life;
        ctx.strokeStyle = g;
        ctx.lineWidth = 1.4;
        ctx.beginPath();
        ctx.moveTo(shoot.x, shoot.y);
        ctx.lineTo(tx, ty);
        ctx.stroke();
        shoot.x += shoot.vx;
        shoot.y += shoot.vy;
        shoot.life -= 0.014;
        if (shoot.life <= 0) shoot = null;
      }
      ctx.globalAlpha = 1;
      raf = requestAnimationFrame(draw);
    };

    resize();
    window.addEventListener("resize", resize);
    window.addEventListener("mousemove", move);
    raf = requestAnimationFrame(draw);
    return () => {
      cancelAnimationFrame(raf);
      window.removeEventListener("resize", resize);
      window.removeEventListener("mousemove", move);
    };
  }, []);

  return <canvas ref={ref} className="absolute inset-0 h-full w-full" aria-hidden data-testid="hero-starfield" />;
};
